export const LabServiceProductCategories = [
    "Anions",
    "Cations (Metals)",
    "Physical Parameters",
    "Hardness Parameters",
    "Microbiology Parameters"
];
